import anime from 'animejs'

import {zeroFill} from '@helpers/utils'
import {Component} from 'lowkey-component'
import {ViewportObserver} from '@services/ViewportObserver'

export class ChartCountup extends Component {

  _viewportObserver: ViewportObserver
  target: HTMLElement | null = null

  constructor(element: HTMLDivElement) {
    super(element)

    this._viewportObserver = new ViewportObserver({margin: '-10%', ratio: 0.10})
  }

  didMount() {

    setTimeout(() => {
      const top = this.element.getBoundingClientRect().top + window.pageYOffset
      const isOver = window.pageYOffset + window.innerHeight > top
      if (isOver) {
        this.animate()
      } else {
        this._viewportObserver.onChange.connect((status) => {
          if (status === 'below') {
            this.animate()
          }
        })
      }
    }, 100) // msecまたないとwindow.pageYOffsetが0
    this._viewportObserver.observe(this.element)

  }

  animate() {
    const target = this.element.querySelector('.js-chart-countup-num') as HTMLSpanElement
    const maxData = target.dataset['value'] || '0'
    const max = parseInt(maxData, 10)
    const data = {count: 0}

    anime({
      targets: data,
      duration: 1200,
      count: max,
      easing: 'easeOutCubic',
      update: () => {
        target.textContent = zeroFill(max.toString().length, Math.floor(data.count))
      }
    })

    this._viewportObserver.disconnect()
  }

  didUnmount() {
    this._viewportObserver.disconnect()
  }

}
